export const fundingSourceImages = {
  tokenEth:
    'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/info/logo.png',
  tokenUsdc:
    'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png',
  tokenMatic:
    'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/polygon/info/logo.png',
  exchangeCoinbase:
    'https://lifinance.github.io/types/src/assets/icons/exchanges/coinbase.svg',
  exchangeBinance:
    'https://lifinance.github.io/types/src/assets/icons/exchanges/binance.svg',
  visa: 'https://lifinance.github.io/types/src/assets/icons/cards/visa.svg',
  mastercard:
    'https://lifinance.github.io/types/src/assets/icons/cards/mastercard.svg',
} as const
